import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title, description, keywords }) => {
    const siteName = 'GradPath';
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    const defaultDescription = 'Find entry-level jobs, internships, and work-integrated learning opportunities in South Africa.';
    const defaultKeywords = 'jobs, internships, graduate, South Africa, careers, entry-level, hiring';

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:type" content="website" />
        </Helmet>
    );
};

export default PageTitle;